<script>
import {
  getKitchenPrinterDeviceListService, addKitchenPrinterDeviceListService,
updateKitchenPrinterDeviceListService, deleteKitchenPrinterDeviceListService
} from "@/helpers/service/api/kitchenPrinterDevice";
import countDownAlert from "@/utils/countDownAlert";
export default {
  name: "kitchenPrinterDevice",
  data() {
    return {
      deviceList: [],
      isOpen: false,
      action: "create",
      form: {
        name: "",
        sn: "",
        isBindShop: true,
        inUse: true,
        printCount: 1
      },
      formRules: {
        name: [ {
          required: true,
          message: this.$locale("setting.kitchenPrinterDevice.plsInputName"),
          trigger: "blur"
        } ],
        sn: [ {
          required: true,
          message: this.$locale("setting.kitchenPrinterDevice.plsInputSN"),
          trigger: "blur"
        } ]
      }
    };
  },
  created() {
    this.getList();
  },
  methods: {
    deleteDevice_fn(row) {
      console.log(row.id)
      let confirmHtml = `<i class="egl-confirm-question">?</i><span class="result-text">${this.$locale("global.delete")} ${row.sn}</span>`;
      this.$confirm(confirmHtml, "", {
        dangerouslyUseHTMLString: true,
        showClose: false,
        showCancelButton: true,
        cancelButtonClass: "egl-btn-white",
        cancelButtonText: this.$locale("global.cancel"),
        showConfirmButton: true,
        confirmButtonClass: "egl-btn-yellow",
        confirmButtonText: this.$locale("global.delete"),
        customClass: "egl-confirm",
        closeOnClickModal: false,
      }).then(() => {
        deleteKitchenPrinterDeviceListService({
          id: row.id
        }).then(res => {
          if (res.success) {
            countDownAlert({ content: this.$locale("global.deleteSuccessfully"),
              callback: () => {
                this.getList();
              } });
          }
        });
      });
    },
    colse_fn() {
      this.$refs.form.resetFields();
      this.isOpen = false;
    },
    getList() {
      getKitchenPrinterDeviceListService({
        cinemaId: window.localStorage.getItem("cinemaId")
      }).then(res => {
        if (res.data && res.data.length > 0) {
          this.deviceList = res.data;
        } else {
          this.deviceList = [];
        }
      });
    },
    openDialog() {
      this.action = "create";
      this.isOpen = true;
    },
    openDetail_fn(row) {
      this.isOpen = true;
      this.action = "edit";
      this.$nextTick(() => {
        this.form = {
          name: row.name,
          id: row.id,
          sn: row.sn,
          isBindShop: row.isBindShop,
          inUse: row.inUse,
          printCount: row.printCount
        };
      });
    },
    save_fn() {
      this.$refs.form.validate(valid => {
        if (valid) {
          const obj = {
            ...this.form,
            cinemaId: window.localStorage.getItem("cinemaId"),
          };
          if (this.action === "create") {
            addKitchenPrinterDeviceListService(obj).then(res => {
              if (res.success) {
                countDownAlert({ content: this.$locale("global.createSuccessfully"),
                  callback: () => {
                    this.isOpen = false;
                    this.getList();
                  } });
              }
            });
          } else {
            updateKitchenPrinterDeviceListService(obj).then(res => {
              if (res.success) {
                countDownAlert({ content: this.$locale("global.updateSuccessfully"),
                  callback: () => {
                    this.isOpen = false;
                    this.getList();
                  } });
              }
            });
          }

        } else {
          setTimeout(() => {
            const isError = document.getElementsByClassName("is-error");
            isError[0].querySelector("input").focus();
          }, 100);

          return false;
        }
      });
    },
    changeHandler(val) {
      const exp = /^[1-9]\d*$/;
      if (exp.test(val)) {
        this.form.printCount = Number(val);
      } else {
        this.form.printCount = 1;
      }
    },
    toggleUse() {
      this.form.inUse = !this.form.inUse;
    }
  }
};
</script>

<template>
  <div class="page-content">
    <h1 class="page-title">{{ $locale("setting.kitchenPrinterDevice.title") }}</h1>
    <el-row :gutter="10" class="search-area">
      <el-col class="ta-r" :lg="24">
        <el-button class="egl-btn-yellow" @click="openDialog">{{ $locale("global.addKitchen") }}</el-button>
      </el-col>
    </el-row>
    <el-table :data="deviceList" class="egl-table list-table">
      <el-table-column :label="$locale('global.name')" prop="name"></el-table-column>
      <el-table-column :label="$locale('setting.kitchenPrinterDevice.sn')" prop="sn"></el-table-column>
      <el-table-column :label="$locale('setting.kitchenPrinterDevice.printCount')" prop="printCount"></el-table-column>
      <el-table-column :label="$locale('global.control')" align="center" width="110">
        <template slot-scope="scope">
          <div class="handle">
            <a @click="openDetail_fn(scope.row)">{{ $locale("global.edit") }}</a>
           <el-divider direction="vertical"></el-divider>
           <a @click="deleteDevice_fn(scope.row)">{{ $locale("global.delete") }}</a>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <el-dialog
      :visible.sync="isOpen"
      width="660px"
      :show-close="true"
      class="egl-dialog-elm channel-dialog"
      title="Kitchen Printer Device 作成"
      :close-on-click-modal="false"
    >
      <el-form ref="form" :model="form" :rules="formRules" label-position="top">
        <el-form-item :label="$locale('global.name')" prop="name">
          <el-input v-model="form.name"></el-input>
        </el-form-item>
        <el-form-item :label="$locale('setting.kitchenPrinterDevice.sn')" prop="sn">
          <el-input v-model="form.sn"></el-input>
        </el-form-item>
        <el-form-item :label="$locale('setting.kitchenPrinterDevice.deviceType')">Kitchen Printer</el-form-item>
        <el-form-item :label="$locale('setting.kitchenPrinterDevice.printCount')" prop="printCount">
          <el-input v-model.number="form.printCount" @input="changeHandler"></el-input>
        </el-form-item>
        <el-button class="egl-btn-red" v-if="form.inUse" @click="toggleUse">
          {{  $locale('setting.kitchenPrinterDevice.printPause') }}</el-button>
        <el-button class="egl-btn-yellow" v-else @click="toggleUse">
          {{  $locale('setting.kitchenPrinterDevice.printResume') }}</el-button>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-row :gutter="20">
          <el-col :span="24">
            <el-button class="egl-btn-white" @click="colse_fn">{{$locale("global.cancel")}}</el-button>
            <el-button class="egl-btn-yellow" @click="save_fn">{{$locale("global.confirm")}}</el-button>
          </el-col>
        </el-row>
      </div>
    </el-dialog>
  </div>
</template>

<style scoped lang="less">

</style>
